import { helper } from '@ember/component/helper';
import { isValidTimestamp as isValid } from '@customerio/fly-components/utils/validators/timestamp';

export function isValidTimestamp([value]) {
  return isValid(value);
}

export default helper(isValidTimestamp);
